module.exports = __webpack_public_path__ + "img/normal_multiplier_3.762b01b2.png";